import { render, staticRenderFns } from "./Layout_StickyHeader.vue?vue&type=template&id=327b55e1&scoped=true&"
import script from "./Layout_StickyHeader.vue?vue&type=script&lang=js&"
export * from "./Layout_StickyHeader.vue?vue&type=script&lang=js&"
import style0 from "./Layout_StickyHeader.vue?vue&type=style&index=0&id=327b55e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b55e1",
  null
  
)

export default component.exports